import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { UsuarioToken } from '../../../models/usuarioToken';

@Injectable()
export class GestaoSsService extends DataService {

  constructor(private http: HttpClient, private ngZone: NgZone) {
    super();
  }

  consultarTokenGestaoSS(token: string, sistema: string): Observable<UsuarioToken> {
    const authHeader = new HttpHeaders();
    authHeader.append('Content-Type', 'application/json; charset=utf-8');
    return this.http.get(this.apiUrlGestaoSS + 'seguranca/GetUsuario/' + token + '/' + sistema, { headers: authHeader })
      .catch(this.handleError);
  }

  redirecionaUsuarioParaoGestaoSS() {
    this.ngZone.runOutsideAngular(() => location.href = this.gestaoSSUrl + 'Home/Logoff');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/services/gestao-ss.service.ts